import { render, staticRenderFns } from "./goodType.vue?vue&type=template&id=03f8d999&scoped=true&"
import script from "./goodType.vue?vue&type=script&lang=js&"
export * from "./goodType.vue?vue&type=script&lang=js&"
import style0 from "./goodType.vue?vue&type=style&index=0&id=03f8d999&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f8d999",
  null
  
)

export default component.exports